/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Title_And_Category_Are_RequireInputs */

const en_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title and category are required`)
};

const es_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título y la categoría son obligatorios`)
};

const fr_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le titre et la catégorie sont requis`)
};

const de_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel und Kategorie sind erforderlich`)
};

const ja_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトルとカテゴリは必須です`)
};

const zh_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题和类别为必填项`)
};

const ar_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان والفئة مطلوبان`)
};

const id_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul dan kategori wajib diisi`)
};

const it_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo e categoria sono obbligatori`)
};

const ru_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название и категория обязательны`)
};

const pt_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título e categoria são obrigatórios`)
};

const ko_title_and_category_are_require = /** @type {(inputs: Title_And_Category_Are_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제목과 카테고리는 필수 항목입니다`)
};

/**
* | output |
* | --- |
* | "Title and category are required" |
*
* @param {Title_And_Category_Are_RequireInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const title_and_category_are_require = /** @type {((inputs?: Title_And_Category_Are_RequireInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Title_And_Category_Are_RequireInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_title_and_category_are_require(inputs)
	if (locale === "es") return es_title_and_category_are_require(inputs)
	if (locale === "fr") return fr_title_and_category_are_require(inputs)
	if (locale === "de") return de_title_and_category_are_require(inputs)
	if (locale === "ja") return ja_title_and_category_are_require(inputs)
	if (locale === "zh") return zh_title_and_category_are_require(inputs)
	if (locale === "ar") return ar_title_and_category_are_require(inputs)
	if (locale === "id") return id_title_and_category_are_require(inputs)
	if (locale === "it") return it_title_and_category_are_require(inputs)
	if (locale === "ru") return ru_title_and_category_are_require(inputs)
	if (locale === "pt") return pt_title_and_category_are_require(inputs)
	return ko_title_and_category_are_require(inputs)
});